import { __ } from '@wordpress/i18n';
import { useBlockProps, RichText, MediaUpload, InspectorControls, URLInput } from '@wordpress/blockEditor';
import { PanelBody, ToggleControl, ColorPalette, BaseControl, Button, RangeControl, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';

export default function Edit({ attributes, setAttributes }) {
    const { id_titre_1Texte, id_titre_1CouleurTexte, id_titre_1Opacite, id_titre_1Afficher, id_paragraphe_1Texte, id_paragraphe_1CouleurTexte, id_paragraphe_1Opacite, id_paragraphe_1Afficher, id_fleche_gaucheId, id_fleche_gaucheAlt, id_fleche_gaucheOpacite, id_fleche_gaucheAfficher, id_article_1_titre_articleTexte, id_article_1_titre_articleCouleurTexte, id_article_1_titre_articleOpacite, id_article_1_titre_articleAfficher, id_article_1_date_articleTexte, id_article_1_date_articleCouleurTexte, id_article_1_date_articleOpacite, id_article_1_date_articleAfficher, id_article_1_extrait_articleTexte, id_article_1_extrait_articleCouleurTexte, id_article_1_extrait_articleOpacite, id_article_1_extrait_articleAfficher, id_article_1_bouton_lecture_articleTexte, id_article_1_bouton_lecture_articleUrl, id_article_1_bouton_lecture_articleCouleurFond, id_article_1_bouton_lecture_articleCouleurTexte, id_article_1_bouton_lecture_articleCouleurBordure, id_article_1_bouton_lecture_articleCouleurFondHover, id_article_1_bouton_lecture_articleCouleurTexteHover, id_article_1_bouton_lecture_articleCouleurBordureHover, id_article_1_bouton_lecture_articleCouleurFondActive, id_article_1_bouton_lecture_articleCouleurTexteActive, id_article_1_bouton_lecture_articleCouleurBordureActive, id_article_1_bouton_lecture_articleOpacite, id_article_1_bouton_lecture_articleAfficher, id_article_1_bouton_lecture_article_texte_1Texte, id_article_1_bouton_lecture_article_texte_1CouleurTexte, id_article_1_bouton_lecture_article_texte_1Opacite, id_article_1_bouton_lecture_article_texte_1Afficher, id_article_1_image_articleId, id_article_1_image_articleAlt, id_article_1_image_articleOpacite, id_article_1_image_articleAfficher, id_article_2_titre_articleTexte, id_article_2_titre_articleCouleurTexte, id_article_2_titre_articleOpacite, id_article_2_titre_articleAfficher, id_article_2_date_articleTexte, id_article_2_date_articleCouleurTexte, id_article_2_date_articleOpacite, id_article_2_date_articleAfficher, id_article_2_extrait_articleTexte, id_article_2_extrait_articleCouleurTexte, id_article_2_extrait_articleOpacite, id_article_2_extrait_articleAfficher, id_article_2_bouton_lecture_articleTexte, id_article_2_bouton_lecture_articleUrl, id_article_2_bouton_lecture_articleCouleurFond, id_article_2_bouton_lecture_articleCouleurTexte, id_article_2_bouton_lecture_articleCouleurBordure, id_article_2_bouton_lecture_articleCouleurFondHover, id_article_2_bouton_lecture_articleCouleurTexteHover, id_article_2_bouton_lecture_articleCouleurBordureHover, id_article_2_bouton_lecture_articleCouleurFondActive, id_article_2_bouton_lecture_articleCouleurTexteActive, id_article_2_bouton_lecture_articleCouleurBordureActive, id_article_2_bouton_lecture_articleOpacite, id_article_2_bouton_lecture_articleAfficher, id_article_2_bouton_lecture_article_texte_1Texte, id_article_2_bouton_lecture_article_texte_1CouleurTexte, id_article_2_bouton_lecture_article_texte_1Opacite, id_article_2_bouton_lecture_article_texte_1Afficher, id_article_2_image_articleId, id_article_2_image_articleAlt, id_article_2_image_articleOpacite, id_article_2_image_articleAfficher, id_article_3_titre_articleTexte, id_article_3_titre_articleCouleurTexte, id_article_3_titre_articleOpacite, id_article_3_titre_articleAfficher, id_article_3_date_articleTexte, id_article_3_date_articleCouleurTexte, id_article_3_date_articleOpacite, id_article_3_date_articleAfficher, id_article_3_extrait_articleTexte, id_article_3_extrait_articleCouleurTexte, id_article_3_extrait_articleOpacite, id_article_3_extrait_articleAfficher, id_article_3_bouton_lecture_articleTexte, id_article_3_bouton_lecture_articleUrl, id_article_3_bouton_lecture_articleCouleurFond, id_article_3_bouton_lecture_articleCouleurTexte, id_article_3_bouton_lecture_articleCouleurBordure, id_article_3_bouton_lecture_articleCouleurFondHover, id_article_3_bouton_lecture_articleCouleurTexteHover, id_article_3_bouton_lecture_articleCouleurBordureHover, id_article_3_bouton_lecture_articleCouleurFondActive, id_article_3_bouton_lecture_articleCouleurTexteActive, id_article_3_bouton_lecture_articleCouleurBordureActive, id_article_3_bouton_lecture_articleOpacite, id_article_3_bouton_lecture_articleAfficher, id_article_3_bouton_lecture_article_texte_1Texte, id_article_3_bouton_lecture_article_texte_1CouleurTexte, id_article_3_bouton_lecture_article_texte_1Opacite, id_article_3_bouton_lecture_article_texte_1Afficher, id_article_3_image_articleId, id_article_3_image_articleAlt, id_article_3_image_articleOpacite, id_article_3_image_articleAfficher, id_fleche_droiteId, id_fleche_droiteAlt, id_fleche_droiteOpacite, id_fleche_droiteAfficher, blocCouleurFond, blocCouleurBordure, blocImageFondId, animCode } = attributes;

    // Récupération dynamique et réactive des URLs avec useSelect
    const { imageUrl, id_fleche_gaucheImageUrl, id_article_1_image_articleImageUrl, id_article_2_image_articleImageUrl, id_article_3_image_articleImageUrl, id_fleche_droiteImageUrl } = useSelect( ( select ) => {
        const media = select( 'core' );
        return {
            imageUrl: blocImageFondId ? media.getMedia( blocImageFondId )?.source_url : null,
            id_fleche_gaucheImageUrl: id_fleche_gaucheId ? media.getMedia( id_fleche_gaucheId )?.source_url : null,
            id_article_1_image_articleImageUrl: id_article_1_image_articleId ? media.getMedia( id_article_1_image_articleId )?.source_url : null,
            id_article_2_image_articleImageUrl: id_article_2_image_articleId ? media.getMedia( id_article_2_image_articleId )?.source_url : null,
            id_article_3_image_articleImageUrl: id_article_3_image_articleId ? media.getMedia( id_article_3_image_articleId )?.source_url : null,
            id_fleche_droiteImageUrl: id_fleche_droiteId ? media.getMedia( id_fleche_droiteId )?.source_url : null
        };
    }, [ blocImageFondId, id_fleche_gaucheId, id_article_1_image_articleId, id_article_2_image_articleId, id_article_3_image_articleId, id_fleche_droiteId ] );

    // Construire le style du bloc avec image de fond en priorité
    const blocStyle = imageUrl 
        ? { 
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            borderColor: blocCouleurBordure
        }
        : { 
            backgroundColor: blocCouleurFond, 
            borderColor: blocCouleurBordure 
        };

    const blockProps = useBlockProps({
        style: blocStyle
    });

    return (
        <>
            <style>{`
        .id_article_1_bouton_lecture_article:hover {
            background-color: ${id_article_1_bouton_lecture_articleCouleurFondHover} !important;
            color: ${id_article_1_bouton_lecture_articleCouleurTexteHover} !important;
            border-color: ${id_article_1_bouton_lecture_articleCouleurBordureHover} !important;
        }
        .id_article_1_bouton_lecture_article:active {
            background-color: ${id_article_1_bouton_lecture_articleCouleurFondActive} !important;
            color: ${id_article_1_bouton_lecture_articleCouleurTexteActive} !important;
            border-color: ${id_article_1_bouton_lecture_articleCouleurBordureActive} !important;
        }
        .id_article_2_bouton_lecture_article:hover {
            background-color: ${id_article_2_bouton_lecture_articleCouleurFondHover} !important;
            color: ${id_article_2_bouton_lecture_articleCouleurTexteHover} !important;
            border-color: ${id_article_2_bouton_lecture_articleCouleurBordureHover} !important;
        }
        .id_article_2_bouton_lecture_article:active {
            background-color: ${id_article_2_bouton_lecture_articleCouleurFondActive} !important;
            color: ${id_article_2_bouton_lecture_articleCouleurTexteActive} !important;
            border-color: ${id_article_2_bouton_lecture_articleCouleurBordureActive} !important;
        }
        .id_article_3_bouton_lecture_article:hover {
            background-color: ${id_article_3_bouton_lecture_articleCouleurFondHover} !important;
            color: ${id_article_3_bouton_lecture_articleCouleurTexteHover} !important;
            border-color: ${id_article_3_bouton_lecture_articleCouleurBordureHover} !important;
        }
        .id_article_3_bouton_lecture_article:active {
            background-color: ${id_article_3_bouton_lecture_articleCouleurFondActive} !important;
            color: ${id_article_3_bouton_lecture_articleCouleurTexteActive} !important;
            border-color: ${id_article_3_bouton_lecture_articleCouleurBordureActive} !important;
        }`}</style>
            {/* BARRE LATÉRALE (INSPECTOR) */}
            <InspectorControls>

                <PanelBody title="Bloc Principal" initialOpen={true}>
                    <BaseControl label="Image de fond">
                        <MediaUpload
                            onSelect={(media) => setAttributes({ blocImageFondId: media.id })}
                            type="image"
                            value={blocImageFondId}
                            render={({ open }) => (
                                <div>
                                    {imageUrl ? (
                                        <div>
                                            <img src={imageUrl} style={{ maxWidth: '100%', marginBottom: '10px' }} />
                                            <Button 
                                                variant="secondary" 
                                                isDestructive
                                                onClick={() => setAttributes({ blocImageFondId: 0 })}>
                                                Supprimer l'image
                                            </Button>
                                        </div>
                                    ) : (
                                        <Button variant="primary" onClick={open}>
                                            Choisir une image de fond
                                        </Button>
                                    )}
                                </div>
                            )}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de fond (fallback)" help="Utilisée si aucune image n'est définie">
                        <ColorPalette
                            value={blocCouleurFond}
                            onChange={(val) => setAttributes({ blocCouleurFond: val })}
                        />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette
                            value={blocCouleurBordure}
                            onChange={(val) => setAttributes({ blocCouleurBordure: val })}
                        />
                    </BaseControl>
                </PanelBody>
                <PanelBody title="titre-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_titre_1Afficher}
                        onChange={(val) => setAttributes({ id_titre_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_titre_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_titre_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_titre_1Opacite}
                        onChange={(val) => setAttributes({ id_titre_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="paragraphe-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_paragraphe_1Afficher}
                        onChange={(val) => setAttributes({ id_paragraphe_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_paragraphe_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_paragraphe_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_paragraphe_1Opacite}
                        onChange={(val) => setAttributes({ id_paragraphe_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="fleche-gauche (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_fleche_gaucheAfficher}
                        onChange={(val) => setAttributes({ id_fleche_gaucheAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_fleche_gaucheAlt}
                            onChange={(val) => setAttributes({ id_fleche_gaucheAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_fleche_gaucheOpacite}
                        onChange={(val) => setAttributes({ id_fleche_gaucheOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_titre_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_1_titre_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_1_titre_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_1_titre_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_titre_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_1_titre_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="date-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_date_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_1_date_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_1_date_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_1_date_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_date_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_1_date_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="extrait-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_extrait_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_1_extrait_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_1_extrait_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_1_extrait_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_extrait_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_1_extrait_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-article (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_bouton_lecture_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleAfficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_article_1_bouton_lecture_articleUrl}
                            onChange={(url) => setAttributes({ id_article_1_bouton_lecture_articleUrl: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurFond} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurTexte} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurBordure} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurFondHover} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurTexteHover} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurBordureHover} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurFondActive} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurTexteActive} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_article_1_bouton_lecture_articleCouleurBordureActive} onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleCouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_bouton_lecture_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_bouton_lecture_article_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_article_1_bouton_lecture_article_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_1_bouton_lecture_article_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_article_1_bouton_lecture_article_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_bouton_lecture_article_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_article_1_bouton_lecture_article_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-article (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_1_image_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_1_image_articleAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_article_1_image_articleAlt}
                            onChange={(val) => setAttributes({ id_article_1_image_articleAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_1_image_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_1_image_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_titre_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_2_titre_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_2_titre_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_2_titre_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_titre_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_2_titre_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="date-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_date_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_2_date_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_2_date_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_2_date_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_date_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_2_date_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="extrait-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_extrait_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_2_extrait_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_2_extrait_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_2_extrait_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_extrait_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_2_extrait_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-article (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_bouton_lecture_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleAfficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_article_2_bouton_lecture_articleUrl}
                            onChange={(url) => setAttributes({ id_article_2_bouton_lecture_articleUrl: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurFond} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurTexte} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurBordure} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurFondHover} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurTexteHover} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurBordureHover} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurFondActive} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurTexteActive} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_article_2_bouton_lecture_articleCouleurBordureActive} onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleCouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_bouton_lecture_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_bouton_lecture_article_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_article_2_bouton_lecture_article_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_2_bouton_lecture_article_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_article_2_bouton_lecture_article_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_bouton_lecture_article_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_article_2_bouton_lecture_article_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-article (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_2_image_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_2_image_articleAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_article_2_image_articleAlt}
                            onChange={(val) => setAttributes({ id_article_2_image_articleAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_2_image_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_2_image_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="titre-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_titre_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_3_titre_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_3_titre_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_3_titre_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_titre_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_3_titre_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="date-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_date_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_3_date_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_3_date_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_3_date_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_date_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_3_date_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="extrait-article (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_extrait_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_3_extrait_articleAfficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_3_extrait_articleCouleurTexte}
                            onChange={(val) => setAttributes({ id_article_3_extrait_articleCouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_extrait_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_3_extrait_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="bouton-article (Bouton)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_bouton_lecture_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleAfficher: val })}
                    />
                    <BaseControl label="URL du bouton">
                        <URLInput
                            value={id_article_3_bouton_lecture_articleUrl}
                            onChange={(url) => setAttributes({ id_article_3_bouton_lecture_articleUrl: url })}
                            isFullWidth
                        />
                    </BaseControl>
                    
                    <h4>État Normal</h4>
                    <BaseControl label="Couleur de fond">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurFond} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurFond: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurTexte} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurTexte: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurBordure} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurBordure: val })} />
                    </BaseControl>
                    
                    <h4>État Hover</h4>
                    <BaseControl label="Couleur de fond (Hover)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurFondHover} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurFondHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Hover)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurTexteHover} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurTexteHover: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Hover)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurBordureHover} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurBordureHover: val })} />
                    </BaseControl>
                    
                    <h4>État Active</h4>
                    <BaseControl label="Couleur de fond (Active)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurFondActive} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurFondActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur du texte (Active)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurTexteActive} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurTexteActive: val })} />
                    </BaseControl>
                    <BaseControl label="Couleur de bordure (Active)">
                        <ColorPalette value={id_article_3_bouton_lecture_articleCouleurBordureActive} onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleCouleurBordureActive: val })} />
                    </BaseControl>
                    
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_bouton_lecture_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="texte-1 (Texte)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_bouton_lecture_article_texte_1Afficher}
                        onChange={(val) => setAttributes({ id_article_3_bouton_lecture_article_texte_1Afficher: val })}
                    />
                    <BaseControl label="Couleur du texte">
                        <ColorPalette
                            value={id_article_3_bouton_lecture_article_texte_1CouleurTexte}
                            onChange={(val) => setAttributes({ id_article_3_bouton_lecture_article_texte_1CouleurTexte: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_bouton_lecture_article_texte_1Opacite}
                        onChange={(val) => setAttributes({ id_article_3_bouton_lecture_article_texte_1Opacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="image-article (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_article_3_image_articleAfficher}
                        onChange={(val) => setAttributes({ id_article_3_image_articleAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_article_3_image_articleAlt}
                            onChange={(val) => setAttributes({ id_article_3_image_articleAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_article_3_image_articleOpacite}
                        onChange={(val) => setAttributes({ id_article_3_image_articleOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="fleche-droite (Image)" initialOpen={false}>
                    <ToggleControl
                        label="Afficher"
                        checked={id_fleche_droiteAfficher}
                        onChange={(val) => setAttributes({ id_fleche_droiteAfficher: val })}
                    />
                    <BaseControl label="Texte alternatif">
                        <TextControl
                            value={id_fleche_droiteAlt}
                            onChange={(val) => setAttributes({ id_fleche_droiteAlt: val })}
                        />
                    </BaseControl>
                    <RangeControl
                        label="Opacité"
                        value={id_fleche_droiteOpacite}
                        onChange={(val) => setAttributes({ id_fleche_droiteOpacite: val })}
                        min={0}
                        max={1}
                        step={0.1}
                    />
                </PanelBody>
                <PanelBody title="Animations" initialOpen={false}>
                    <BaseControl 
                        label="Code d'animation" 
                        help="JavaScript exécuté">
                        <textarea
                            value={animCode}
                            onChange={(e) => setAttributes({ animCode: e.target.value })}
                            placeholder="Mon animation ici..."
                            rows={8}
                            style={{ width: '100%', fontFamily: 'monospace', fontSize: '12px' }}
                        />
                    </BaseControl>
                </PanelBody>
            </InspectorControls>

            {/* VISUEL PRINCIPAL */}
            <section { ...blockProps }>
                {/* id_bloc */}
                <div className="container-fluid">
                    {/* id_titre_1 */}
                    <div className="row">
                        <div className="col-12">
                            {id_titre_1Afficher && (
                                <RichText 
                                    tagName="h1" 
                                    className="id_titre_1 " 
                                    value={id_titre_1Texte} 
                                    onChange={(val) => setAttributes({ id_titre_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_titre_1CouleurTexte, opacity: id_titre_1Opacite }} 
                                />
                            )}
                        </div>
                    </div>
                    {/* end-id_titre_1 */}
                    {/* id_paragraphe_1 */}
                    <div className="row">
                        <div className="col-12">
                            {id_paragraphe_1Afficher && (
                                <RichText 
                                    tagName="p" 
                                    className="id_paragraphe_1 " 
                                    value={id_paragraphe_1Texte} 
                                    onChange={(val) => setAttributes({ id_paragraphe_1Texte: val })} 
                                    placeholder="Saisir le texte..." 
                                    style={{ color: id_paragraphe_1CouleurTexte, opacity: id_paragraphe_1Opacite }} 
                                />
                            )}
                        </div>
                    </div>
                    {/* end-id_paragraphe_1 */}
                    {/* id_fleche_gauche */}
                    {id_fleche_gaucheAfficher && (
                        <MediaUpload
                            onSelect={(media) => setAttributes({ id_fleche_gaucheId: media.id, id_fleche_gaucheAlt: media.alt })}
                            type="image"
                            value={id_fleche_gaucheId}
                            render={({ open }) => (
                                <div onClick={open} style={{ cursor: 'pointer' }}>
                                    {id_fleche_gaucheImageUrl ? (
                                        <img className="id_fleche_gauche" src={id_fleche_gaucheImageUrl} alt={id_fleche_gaucheAlt} style={{ opacity: id_fleche_gaucheOpacite }} />
                                    ) : (
                                        <Button variant="secondary">Ajouter une image</Button>
                                    )}
                                </div>
                            )}
                        />
                    )}
                    {/* end-id_fleche_gauche */}
                    {/* id_fleche_droite */}
                    {id_fleche_droiteAfficher && (
                        <MediaUpload
                            onSelect={(media) => setAttributes({ id_fleche_droiteId: media.id, id_fleche_droiteAlt: media.alt })}
                            type="image"
                            value={id_fleche_droiteId}
                            render={({ open }) => (
                                <div onClick={open} style={{ cursor: 'pointer' }}>
                                    {id_fleche_droiteImageUrl ? (
                                        <img className="id_fleche_droite" src={id_fleche_droiteImageUrl} alt={id_fleche_droiteAlt} style={{ opacity: id_fleche_droiteOpacite }} />
                                    ) : (
                                        <Button variant="secondary">Ajouter une image</Button>
                                    )}
                                </div>
                            )}
                        />
                    )}
                    {/* end-id_fleche_droite */}
                    <div className="row justify-content-center align-items-stretch">
                        {/* id_article_1 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex">
                            <article>
                                {/* id_article_1_titre_article */}
                                {id_article_1_titre_articleAfficher && (
                                    <RichText 
                                        tagName="h2" 
                                        className="id_article_1_titre_article " 
                                        value={id_article_1_titre_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_1_titre_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_1_titre_articleCouleurTexte, opacity: id_article_1_titre_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_1_titre_article */}
                                {/* id_article_1_date_article */}
                                {id_article_1_date_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_1_date_article " 
                                        value={id_article_1_date_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_1_date_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_1_date_articleCouleurTexte, opacity: id_article_1_date_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_1_date_article */}
                                {/* id_article_1_extrait_article */}
                                {id_article_1_extrait_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_1_extrait_article " 
                                        value={id_article_1_extrait_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_1_extrait_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_1_extrait_articleCouleurTexte, opacity: id_article_1_extrait_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_1_extrait_article */}
                                {/* id_article_1_image_article */}
                                {id_article_1_image_articleAfficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_article_1_image_articleId: media.id, id_article_1_image_articleAlt: media.alt })}
                                        type="image"
                                        value={id_article_1_image_articleId}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_article_1_image_articleImageUrl ? (
                                                    <img className="id_article_1_image_article" src={id_article_1_image_articleImageUrl} alt={id_article_1_image_articleAlt} style={{ opacity: id_article_1_image_articleOpacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_article_1_image_article */}
                                {/* id_article_1_bouton_lecture_article */}
                                {id_article_1_bouton_lecture_articleAfficher && (
                                    <a 
                                        className="btn id_article_1_bouton_lecture_article"
                                        role="button"
                                        onClick={(e) => e.preventDefault()}
                                        style={{
                                            backgroundColor: id_article_1_bouton_lecture_articleCouleurFond,
                                            color: id_article_1_bouton_lecture_articleCouleurTexte,
                                            borderColor: id_article_1_bouton_lecture_articleCouleurBordure,
                                            opacity: id_article_1_bouton_lecture_articleOpacite,
                                            cursor: 'default'
                                        }}
                                    >
                                        <RichText
                                            tagName="span"
                                            value={id_article_1_bouton_lecture_articleTexte}
                                            onChange={(val) => setAttributes({ id_article_1_bouton_lecture_articleTexte: val })}
                                            placeholder="Texte du bouton..."
                                        />
                                    </a>
                                )}
                                {/* end-id_article_1_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_1 */}
                        {/* id_article_2 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex d-none d-md-flex">
                            <article>
                                {/* id_article_2_titre_article */}
                                {id_article_2_titre_articleAfficher && (
                                    <RichText 
                                        tagName="h2" 
                                        className="id_article_2_titre_article " 
                                        value={id_article_2_titre_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_2_titre_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_2_titre_articleCouleurTexte, opacity: id_article_2_titre_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_2_titre_article */}
                                {/* id_article_2_date_article */}
                                {id_article_2_date_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_2_date_article " 
                                        value={id_article_2_date_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_2_date_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_2_date_articleCouleurTexte, opacity: id_article_2_date_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_2_date_article */}
                                {/* id_article_2_extrait_article */}
                                {id_article_2_extrait_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_2_extrait_article " 
                                        value={id_article_2_extrait_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_2_extrait_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_2_extrait_articleCouleurTexte, opacity: id_article_2_extrait_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_2_extrait_article */}
                                {/* id_article_2_image_article */}
                                {id_article_2_image_articleAfficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_article_2_image_articleId: media.id, id_article_2_image_articleAlt: media.alt })}
                                        type="image"
                                        value={id_article_2_image_articleId}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_article_2_image_articleImageUrl ? (
                                                    <img className="id_article_2_image_article" src={id_article_2_image_articleImageUrl} alt={id_article_2_image_articleAlt} style={{ opacity: id_article_2_image_articleOpacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_article_2_image_article */}
                                {/* id_article_2_bouton_lecture_article */}
                                {id_article_2_bouton_lecture_articleAfficher && (
                                    <a 
                                        className="btn id_article_2_bouton_lecture_article"
                                        role="button"
                                        onClick={(e) => e.preventDefault()}
                                        style={{
                                            backgroundColor: id_article_2_bouton_lecture_articleCouleurFond,
                                            color: id_article_2_bouton_lecture_articleCouleurTexte,
                                            borderColor: id_article_2_bouton_lecture_articleCouleurBordure,
                                            opacity: id_article_2_bouton_lecture_articleOpacite,
                                            cursor: 'default'
                                        }}
                                    >
                                        <RichText
                                            tagName="span"
                                            value={id_article_2_bouton_lecture_articleTexte}
                                            onChange={(val) => setAttributes({ id_article_2_bouton_lecture_articleTexte: val })}
                                            placeholder="Texte du bouton..."
                                        />
                                    </a>
                                )}
                                {/* end-id_article_2_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_2 */}
                        {/* id_article_3 */}
                        <div className="col-12 col-md-6 col-lg-4 d-flex d-none d-lg-flex">
                            <article>
                                {/* id_article_3_titre_article */}
                                {id_article_3_titre_articleAfficher && (
                                    <RichText 
                                        tagName="h2" 
                                        className="id_article_3_titre_article " 
                                        value={id_article_3_titre_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_3_titre_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_3_titre_articleCouleurTexte, opacity: id_article_3_titre_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_3_titre_article */}
                                {/* id_article_3_date_article */}
                                {id_article_3_date_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_3_date_article " 
                                        value={id_article_3_date_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_3_date_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_3_date_articleCouleurTexte, opacity: id_article_3_date_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_3_date_article */}
                                {/* id_article_3_extrait_article */}
                                {id_article_3_extrait_articleAfficher && (
                                    <RichText 
                                        tagName="p" 
                                        className="id_article_3_extrait_article " 
                                        value={id_article_3_extrait_articleTexte} 
                                        onChange={(val) => setAttributes({ id_article_3_extrait_articleTexte: val })} 
                                        placeholder="Saisir le texte..." 
                                        style={{ color: id_article_3_extrait_articleCouleurTexte, opacity: id_article_3_extrait_articleOpacite }} 
                                    />
                                )}
                                {/* end-id_article_3_extrait_article */}
                                {/* id_article_3_image_article */}
                                {id_article_3_image_articleAfficher && (
                                    <MediaUpload
                                        onSelect={(media) => setAttributes({ id_article_3_image_articleId: media.id, id_article_3_image_articleAlt: media.alt })}
                                        type="image"
                                        value={id_article_3_image_articleId}
                                        render={({ open }) => (
                                            <div onClick={open} style={{ cursor: 'pointer' }}>
                                                {id_article_3_image_articleImageUrl ? (
                                                    <img className="id_article_3_image_article" src={id_article_3_image_articleImageUrl} alt={id_article_3_image_articleAlt} style={{ opacity: id_article_3_image_articleOpacite }} />
                                                ) : (
                                                    <Button variant="secondary">Ajouter une image</Button>
                                                )}
                                            </div>
                                        )}
                                    />
                                )}
                                {/* end-id_article_3_image_article */}
                                {/* id_article_3_bouton_lecture_article */}
                                {id_article_3_bouton_lecture_articleAfficher && (
                                    <a 
                                        className="btn id_article_3_bouton_lecture_article"
                                        role="button"
                                        onClick={(e) => e.preventDefault()}
                                        style={{
                                            backgroundColor: id_article_3_bouton_lecture_articleCouleurFond,
                                            color: id_article_3_bouton_lecture_articleCouleurTexte,
                                            borderColor: id_article_3_bouton_lecture_articleCouleurBordure,
                                            opacity: id_article_3_bouton_lecture_articleOpacite,
                                            cursor: 'default'
                                        }}
                                    >
                                        <RichText
                                            tagName="span"
                                            value={id_article_3_bouton_lecture_articleTexte}
                                            onChange={(val) => setAttributes({ id_article_3_bouton_lecture_articleTexte: val })}
                                            placeholder="Texte du bouton..."
                                        />
                                    </a>
                                )}
                                {/* end-id_article_3_bouton_lecture_article */}
                            </article>
                        </div>
                        {/* end-id_article_3 */}
                    </div>
                </div>
                {/* end-id_bloc */}
            </section>
        </>
    );
}